import * as React from 'react'
import styles from './SplitViewToggleButton.sass'

interface SplitViewToggleButtonProps
  extends React.RefAttributes<HTMLAnchorElement> {
  children?: React.ReactNode
  position?: 'left' | 'right'
  onClick?: React.MouseEventHandler
}

/**
 " Split View Toggle Button
 */
export const SplitViewToggleButton = React.forwardRef(
  function SplitViewToggleButton(
    { position, children, onClick }: SplitViewToggleButtonProps,
    ref: React.Ref<HTMLAnchorElement>,
  ) {
    return (
      <div
        className={
          position === 'right'
            ? styles.toggleContainerRight
            : styles.toggleContainerLeft
        }
      >
        <a className={styles.toggle} onClick={onClick} ref={ref}>
          {children}
        </a>
      </div>
    )
  },
)
